module.exports = __webpack_public_path__ + "static/media/professional-services.193f00a4.svg";